export const formatPrice = (price) => {
    const currency = window.Eshop ? window.Eshop.options.currency : undefined;

    let options = {
        decimals: 2,
        decimal_point: ',',
        thousands_separator: ' ',
        symbol_left: '',
        symbol_right: '€'
    };

    if (currency !== undefined) {
        options = { ...options, ...currency };
    }

    var n = typeof price === 'string' || price instanceof String ? parseFloat(price.replace(' ', '').replace(',', '.')) : price,
        sign = n < 0 ? "-" : "",
        i = parseInt(n = Math.abs(+n || 0).toFixed(options.decimals)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;

    return sign + options.symbol_left + (j ? i.substr(0, j) + options.thousands_separator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + options.thousands_separator) + (options.decimals ? options.decimal_point + Math.abs(n - i).toFixed(options.decimals).slice(2) : "") + " " + options.symbol_right;
}
